import { CURRENCY, EUR } from "../../config";

function parseLocalizedNumber(inputValue: string): number {
  const sanitizedString = inputValue.replace(",", ".").replace("%", "");
  return parseFloat(sanitizedString);
}

const shouldShowDecimal = (value: number, decimalPlaces: number): number => {
  return value % 1 !== 0 ? decimalPlaces : 0;
};

function getPrefixAndSuffix(value: string): {
  prefix: string;
  suffix: string;
} {
  const billion = "billion";
  const million = "million";

  const percent = "%";

  let prefix = "";
  let suffix = "";

  if (value.includes(billion)) {
    suffix = "B";
  }
  if (value.includes(million)) {
    suffix = "M";
  }
  if (value.includes(percent)) {
    suffix = percent;
  }

  if (value.includes(CURRENCY)) {
    prefix = CURRENCY;
  }

  if (value.includes("USD")) {
    prefix = "$";
  }

  if (value.includes(EUR)) {
    prefix = "€";
  }

  return { prefix, suffix };
}

export const getCalculations = (
  value: number | string,
  unit: string | undefined,
  decimalPlaces: number,
  skip?: boolean
) => {
  const options: {
    prefix?: string;
    suffix?: string;
    decimalPlaces?: number;
    formattingFn?: () => any;
  } = {};
  if (typeof unit === "string") {
    const { prefix, suffix } = getPrefixAndSuffix(unit);
    options.prefix = prefix;
    options.suffix = suffix;
    if (suffix === "B" && decimalPlaces > 1) {
      decimalPlaces = 1;
    }
  }
  const formattedValue: number =
    typeof value === "string" ? parseLocalizedNumber(value) : value;
  options.decimalPlaces = shouldShowDecimal(formattedValue, decimalPlaces);

  if (skip) {
    options.formattingFn = () => "-";
  }

  return options;
};

export const formatValue = (value: string | number): number => {
  if (typeof value === "string") {
    return parseLocalizedNumber(value);
  }

  return value;
};
